export default __webpack_public_path__ + "mini-icon-android-12@2x.png";